import type { ReactNode } from 'react'
import React from 'react'

import type { MuxPlayerProps } from '@mux/mux-player-react'
import MuxPlayerComponent from '@mux/mux-player-react'

import * as S from './styled'

type Props = MuxPlayerProps & {
  vertical?: boolean
  children?: ReactNode
}

export const MuxPlayer = ({ children, vertical, ...props }: Props) => (
  <S.Container vertical={vertical}>
    <S.Global />
    <MuxPlayerComponent {...props} preferPlayback="mse" />
    {children}
  </S.Container>
)
